import styled from "styled-components";

export const LocationPath = styled.div`
  //max-width: 60%;
  text-wrap: pretty;
`;